export default "__VITE_ASSET__BNsdB$N0__"